<template>
  <div id="yzsmap">
    <transition name="el-fade-in">
      <div
        class="project-map-type"
        v-show="layerLegendShow"
      >
        <el-row :gutter="20">
          <el-col
            :span="12"
            v-for="mapLegend in mapLegends"
            :key="mapLegend.id"
          >
            <div class="bg-purple project-map-type-warp">
              <span>{{mapLegend.statusName}}</span>
              <span :style="{ backgroundColor: mapLegend.color, width: '35px' }"></span>
            </div>
          </el-col>
        </el-row>
      </div>
    </transition>
  </div>
</template>

<script>
import 'ol/ol.css'
import { Map, View } from 'ol'
import TileLayer from 'ol/layer/Tile'
import Projection from 'ol/proj/Projection.js'
import WMTS from 'ol/source/WMTS'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import WKT from 'ol/format/WKT'
import { Fill, Stroke, Style, Text } from 'ol/style'
import {
  getProjectMap, getProjectMapCoordinates, getProjectMapLayers, getMapLegend, getOrgMapServices, getSystemMap, getCountyProjectMapLayers
} from '../request/mapApi'
// import { setSession } from '../request/index'
export default {
  data() {
    return {
      projectId: '',
      projectName: '',
      token: '',
      sessionid: '',
      yzsmap: null,
      mapInfo: {
        mapServerType: '',
        mapUrl: '', // 地图服务地址
        shpUrl: '', // 房屋面数据服务地址
        defaultMapServiceMode: 0, // 默认地图启动模式，0二维，1三维
        enableThreed: 1, // 是否启动3D服务默认 0不启动 1启动
        format: '', // 地图文件格式
        matrixset: '', // 坐标参考系统 本机SRS EPSG:2432
        layers: '', // 地图服务默认图层
        maxZoom: 19, // 地图最大放缩等级 默认19
        minZoom: 1, // 地图最小放缩等级默认1
        defaultZoom: 16, // 地图默认放缩等级 默认值 16
        bounds: [], // 地图显示边框范围minx,miny,maxx,maxy
        resolutions: [], // 地图切片大小
        gridNames: [], // 地图切片名称
        isTiles: 1, // 地图是否采用切片 1 采用切片 0 不采用切片，默认切片
        tileSize: [256, 256], // 切片大小
        extent: [], // 地图切片信息范围
        origin: [], // 地图原点坐标
        centerX: 0, // 中心点坐标X
        centerY: 0, // 中心点坐标Y
        mousePositionControl: '' // 鼠标坐标
      },
      layerTableData: '',
      mapLegends: '',
      orgLevel: '',
      orgId: '',
      layerLegendShow: false
    }
  },
  methods: {
    getMapConfigInfo(data) {
      if (data) {
        this.mapInfo.mapServerType = data.mapServerType
        this.mapInfo.mapUrl = data.mapUrl
        this.mapInfo.shpUrl = data.mapShpUrl
        this.mapInfo.defaultMapServiceMode = data.defaultMapServiceMode
        this.mapInfo.enableThreed = data.enableThreed
        this.mapInfo.format = data.mapFormat
        this.mapInfo.matrixset = data.mapMatrixset
        this.mapInfo.layers = data.mapLayers
        this.mapInfo.maxZoom = data.mapMaxZoom
        this.mapInfo.minZoom = data.mapMinZoom
        this.mapInfo.defaultZoom = data.mapDefaultZoom
        this.mapInfo.bounds = data.mapBounds.replace(/\s+/g, '').split(',').map(Number)
        this.mapInfo.resolutions = data.mapResolutions.replace(/\s+/g, '').split(',').map(Number)
        this.mapInfo.gridNames = data.mapGridNames.replace(/\s+/g, '').split(',')
        this.mapInfo.isTiles = data.mapIsTiles
        this.mapInfo.extent = data.mapExtent.replace(/\s+/g, '').split(',').map(Number)
        this.mapInfo.origin = data.mapOrigin.replace(/\s+/g, '').split(',').map(Number)
        this.mapInfo.centerX = (this.mapInfo.bounds[0] + this.mapInfo.bounds[2]) / 2
        this.mapInfo.centerY = (this.mapInfo.bounds[1] + this.mapInfo.bounds[3]) / 2
        this.initMap()
      } else {
      }
    },
    init() {
      // this.projectId = '1161468824713695233'
      //  CITY(1, "市级机构"),
      //  COUNTY(2, "区县级机构"),
      //  TOWN(3, "街道级机构"),
      //  NO_GOV(4,"非政府机构");
      if (Number(this.orgLevel) === 3) {
        getProjectMap(this.projectId).then(data => {
          this.getMapConfigInfo(data)
        })
      } else {
        getOrgMapServices(this.orgId).then(res => {
          if (!res) {
            this.$message({
              type: 'success',
              message: '未查询到当前地图配置信息!'
            })
            return
          }
          let mapServiceId = res[0].id || ''
          getSystemMap(this.orgId, mapServiceId).then(data => {
            this.getMapConfigInfo(data)
          }, () => {
            this.$message({
              type: 'success',
              message: '地图服务初始化失败!'
            })
          })
        }, () => {
          this.$message({
            type: 'success',
            message: '地图服务初始化失败!'
          })
        })
      }
    },
    initMap() {
      let viewProj = new Projection({
        code: this.mapInfo.matrixset,
        extent: this.mapInfo.extent
      })
      this.yzsmap = new Map({
        target: 'yzsmap',
        layers: [
          new TileLayer({
            source: new WMTS({
              format: this.mapInfo.format,
              layer: this.mapInfo.layers,
              matrixSet: this.mapInfo.matrixset,
              style: '',
              version: '1.0.0',
              url: this.mapInfo.mapUrl,
              tileGrid: new WMTSTileGrid({
                extent: this.mapInfo.extent,
                origin: this.mapInfo.origin,
                resolutions: this.mapInfo.resolutions,
                matrixIds: this.mapInfo.gridNames,
                tileSize: this.mapInfo.tileSize
              })
            }),
            extent: this.mapInfo.bounds,
            opacity: 1
          })
        ],
        view: new View({
          projection: viewProj,
          center: [this.mapInfo.centerX, this.mapInfo.centerY],
          zoom: this.mapInfo.defaultZoom,
          extent: this.mapInfo.extent
        })
      })
      this.getProjectMapLayers()
      this.getProjectMapLegend()
      this.$emit('getMapObject', this.yzsmap)
    },
    // 获取项目地图图层
    getProjectMapLayers() {
      if (this.orgLevel === 3) {
        getProjectMapLayers(this.projectId).then(res => {
          var mapLayers = res.list
          this.layerTableData = mapLayers
          let zIndex = 20
          for (let layerData of mapLayers) {
            this.getProjectMapCoordinates(zIndex, layerData)
            zIndex++
          }
        })
      } else {
        getCountyProjectMapLayers(this.orgId, this.projectId, '').then(res => {
          var mapLayers = res.list
          this.layerTableData = mapLayers
          let zIndex = 20
          for (let layerData of mapLayers) {
            if (layerData.mapLayerNumber === 'house_area_layer' || layerData.mapLayerNumber === 'project_redline_layer') {
              this.getProjectMapCoordinates(zIndex, layerData)
              zIndex++
            }
          }
        })
      }
    },
    getProjectMapCoordinates(zIndex, layerData) {
      if (layerData.id === undefined || layerData.id === null) {
        return false
      }
      getProjectMapCoordinates(layerData.projectId, layerData.id).then(res => {
        if (res != null) {
          this.renderGeoJsonGeometryMap(zIndex, layerData, res.layerGeojson, res.centerPoint)
        }
      })
    },
    isUndef(v) {
      return v === undefined || v === null || v === ''
    },
    colorRgba(color, alphaparam) {
      if (this.isUndef(color)) {
        return ''
      }
      const alpha = alphaparam || 1
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      if (color && reg.test(color)) {
        if (color.length === 4) {
          let sColorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            sColorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = sColorNew
        }
        let sColorChange = []
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return 'rgba(' + sColorChange[0] + ', ' + sColorChange[1] + ', ' + sColorChange[2] + ', ' + alpha + ')'
      } else {
        return color
      }
    },
    renderGeoJsonGeometryMap(zIndex, layerData, layerGeojson, layerCenterPoint) {
      if (layerGeojson === undefined || layerGeojson === null) {
        return
      }
      let householdSource = new VectorSource({
        features: (new GeoJSON()).readFeatures(layerGeojson)
      })
      let visible = layerData.isShowLayer === 1
      let householdLayer = new VectorLayer({
        visible: visible,
        zIndex: zIndex,
        source: householdSource,
        layerid: layerData.id,
        projectId: this.projectId
      })
      if (householdLayer.getSource().getState() === 'ready') {
        let features = householdLayer.getSource().getFeatures()
        if (layerData.mapLayerNumber === 'house_area_layer') {
          this.renderHouseFeaturesStyle(features, layerData)
        } else {
          this.renderFeaturesStyle(features, layerData)
        }
      }
      this.yzsmap.addLayer(householdLayer)
      if (layerData.mapLayerNumber === 'project_redline_layer' && layerCenterPoint !== null && layerCenterPoint !== undefined) {
        let wkt = new WKT()
        let geometry = wkt.readGeometry(layerCenterPoint)
        this.yzsmap.getView().setCenter(geometry.getCoordinates())
      }
      // if (householdLayer) {
      //   let extent = householdLayer.getSource().getExtent()
      //   this.yzsmap.getView().fit(extent, { size: this.yzsmap.getSize() })
      // }
    },
    renderHouseFeaturesStyle(features, layerData) { // 读取分户图层演示
      // let showLabel = layerData.isShowLabel === 1
      let strokeWidth = layerData.width === undefined ? 1 : layerData.width
      let borderColor = layerData.borderColor === undefined ? '#ffff00' : layerData.borderColor
      let opacity = layerData.opacity === undefined ? 0.5 : layerData.opacity
      for (let i = 0, len = features.length; i < len; i++) {
        let userDataStr = features[i].get('userdata')
        let color = features[i].get('color')
        let fillColor = 'rgba(255, 255, 0, 0.2)'
        if (color !== undefined && color !== '' && color !== null) {
          fillColor = this.colorRgba(color, opacity)
        }
        let userData = ''
        let text = ''
        let strokeColor = borderColor
        if (userDataStr !== undefined && userDataStr.length > 0) {
          userData = JSON.parse(userDataStr)
          if (userData.length === 1) {
            text = userData[0].propertyOwner + '\n' + userData[0].householdCode
          } else {
            text = '总共 ' + userData.length + '个分户'
          }
        }
        // if (!showLabel) {
        //   text = ''
        // }
        features[i].setStyle(
          new Style({
            cursor: 'crosshair',
            fill: new Fill({
              color: fillColor
            }),
            stroke: new Stroke({
              color: strokeColor,
              width: strokeWidth
            }),
            text: new Text({
              font: '12px Calibri,sans-serif',
              fill: new Fill({
                color: '#000'
              }),
              stroke: new Stroke({
                color: '#fff',
                width: 2
              }),
              text: text
            }),
            zIndex: 66
          })
        )
      }
    },
    renderFeaturesStyle(features, layerData) { // 渲染非分户相关业务图层样式
      // let showLabel = layerData.isShowLabel === 1
      let strokeWidth = layerData.width === undefined ? 1 : layerData.width // 线的宽度
      let borderColor = layerData.borderColor === undefined ? '#ffff00' : layerData.borderColor // 边缘颜色
      let opacity = layerData.opacity === undefined ? 0.5 : layerData.opacity // 透明度
      let fillColor = layerData.mapLayerColor === undefined ? '#ffff00' : layerData.mapLayerColor // 填充色
      fillColor = this.colorRgba(fillColor, opacity)
      for (let i = 0, len = features.length; i < len; i++) {
        let userDataStr = features[i].get('userdata')
        let userData = ''
        let text = ''
        if (userDataStr !== undefined && userDataStr.length > 0) {
          userData = JSON.parse(userDataStr)
          if (userData.length === 1) {
            text = userData[0].value
          } else {
            userData.forEach(function (ud, i) {
              if (i <= 3) {
                text += ud.structShowName + '\n' + ud.value + '\n'
              }
            })
          }
        }
        // if (!showLabel) {
        //   text = ''
        // }
        features[i].setStyle(
          new Style({
            cursor: 'crosshair',
            fill: new Fill({
              color: fillColor
            }),
            stroke: new Stroke({
              color: borderColor,
              width: strokeWidth
            }),
            text: new Text({
              font: '12px Calibri,sans-serif',
              fill: new Fill({
                color: '#000'
              }),
              stroke: new Stroke({
                color: '#fff',
                width: 2
              }),
              text: text
            }),
            zIndex: 50
          })
        )
      }
    },
    // 获取项目地图图例
    getProjectMapLegend() {
      getMapLegend(this.projectId).then(res => {
        this.mapLegends = res
        if (res.length > 0) {
          this.layerLegendShow = true
        }
      })
    },
    getQueryString(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [''])[1].replace(/\+/g, '%20')) || null
    }
  },
  created() {
    // this.projectId = '1161468824713695233'
    this.projectId = this.getQueryString('projectId') ? this.getQueryString('projectId') : null
    // this.token = this.getQueryString('token') ? this.getQueryString('token') : null
    // this.sessionid = this.getQueryString('sessionid') ? this.getQueryString('sessionid') : null
    this.orgLevel = this.getQueryString('orgLevel') ? this.getQueryString('orgLevel') : null
    this.orgId = this.getQueryString('orgId') ? this.getQueryString('orgId') : null
    this.projectName = this.getQueryString('projectName') ? this.getQueryString('projectName') : '地图'
    document.title = this.projectName
    // setSession('token', this.token)
    // setSession('sessionid', this.sessionid)
    this.init()
  }
}
</script>

<style>
#yzsmap {
  position: relative;
  height: 98%;
  width: 100%;
}
div {
  box-sizing: border-box;
}
.project-map-type {
  padding: 9px;
  z-index: 999;
  position: absolute;
  width: 10%;
  height: 17%;
  min-width: 242px;
  min-height: 150px;
  max-width: 300px;
  max-height: 200px;
  background-color: rgba(44, 118, 124, 0.6);
  box-shadow: 0px 0px 5px 3px rgba(44, 118, 124, 0.6);
  border: 1px solid #73ffff;
  right: 1%;
  bottom: 3%;
  margin: 0;
}
.project-map-type-warp {
  text-align: right;
}
.el-col-12 {
  margin-bottom: 5px;
}
.el-col {
  float: left;
}
span {
  display: inline-block;
  font-size: 12px;
  height: 20px;
  color: #fff;
  line-height: 20px;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue